"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _config = _interopRequireDefault(require("../config"));
var _templateObject;
var CurrencySymbol = _styledComponents["default"].span(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  color: ", ";\n  &::before {\n    content: '", "';\n    margin-right: 5px;\n  }\n"])), function (_ref) {
  var contrasting = _ref.contrasting;
  return contrasting ? '#848485' : undefined;
}, _config["default"].currencySymbol);
var _default = exports["default"] = CurrencySymbol;